export const selectStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #687073",
    borderRadius: 6,
    height: 50,
    outline: "none",
    boxShadow: "none !important",
  }),

  menu: (styles) => ({
    ...styles,
    borderRadius: 6,
  }),
};
export const selectErrorStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #dc3545",
    borderRadius: 6,
    height: 50,
    outline: "none",
    boxShadow: "none !important",
  }),

  menu: (styles) => ({
    ...styles,
    borderRadius: 6,
  }),
};